import {  gql } from '@apollo/client';
import { useQuery } from '@apollo/client/react';

const qry = gql`query RandomRecs($num_recs: Int, $num_invalid: Int, $brand_filter: String) {
  RandomRecs(num_recs: $num_recs, num_invalid: $num_invalid, brand_filter: $brand_filter) {
    recs {
      sessionid
      rownum
      fullsource
      cbp
      assignedbrand
      assignedcompany
      assignedproductname
      brand
      matchedgs1path
      merchantname
      productdescription
      productname
      upc
      iscorrect
      omone
      isvalid
      passoddmanfilter
      validationreasoning
    }
  }
}`;

export function GetData(numRecs, numInvalid, brandFilter) {
    return useQuery(qry, { variables: { num_recs: numRecs || 0, num_invalid: numInvalid || 0, brand_filter: brandFilter || ''} });
}
